__turbopack_context__.v({
  "paragraph": "paragraph-component-module-scss-module__DZQH_W__paragraph",
  "paragraph--collapsable": "paragraph-component-module-scss-module__DZQH_W__paragraph--collapsable",
  "paragraph--expanded": "paragraph-component-module-scss-module__DZQH_W__paragraph--expanded",
  "paragraph__container": "paragraph-component-module-scss-module__DZQH_W__paragraph__container",
  "paragraph__gradient": "paragraph-component-module-scss-module__DZQH_W__paragraph__gradient",
  "paragraph__read-more": "paragraph-component-module-scss-module__DZQH_W__paragraph__read-more",
  "paragraph__read-more-button": "paragraph-component-module-scss-module__DZQH_W__paragraph__read-more-button",
});
